import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import ConfirmationButton from "./common/confirmationButton";
import UTable from "./common/table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faStore, faMobile } from "@fortawesome/free-solid-svg-icons";



class StatusReportFiltersTable extends Component {
  columns = [
    {
      path: "name",
      label: "Nazwa filtru",
    },
    {
      path: "type",
      label: "Typ",
      content: (item) => {
        const isShop = item.type === "shops";
        return (
          <Badge bg={isShop ? "primary" : "info"}>
            <FontAwesomeIcon icon={isShop ? faStore : faMobile} className="me-1" />
            {isShop ? "Sklepy" : "Urządzenia"}
          </Badge>
        );
      },
    },
    {
      path: "data",
      label: "Parametry",
      content: (item) => {
        if (!item.data[item.type]) return "-";
        

        const entries = Object.entries(item.data[item.type]).slice(0, 3); // Pokazujemy maksymalnie 3 parametry
        
        if (entries && entries.length === 0) return "-";
        
        return (
          <div className="small">
            {/* {entries.map(([key, value]) => (
              <div key={key}>
                <strong>{key}:</strong> {value}
              </div>
            ))}
            {Object.keys(item.data).length > 3 && (
              <div className="text-muted">...</div>
            )} */}
          </div>
        );
      },
    },
    {
      path: "activeInSections",
      label: "Aktywne sekcje",
      content: (item) => {
        if (!item.activeInSections || item.activeInSections.length === 0) {
          return <Badge bg="light" text="dark">Brak</Badge>;
        }
        
        return (
          <div>
            {item.activeInSections.slice(0, 2).map((section, index) => (
              <Badge key={index} bg="success" className="me-1 mb-1">
                {section}
              </Badge>
            ))}
            {item.activeInSections.length > 2 && (
              <Badge bg="secondary">+{item.activeInSections.length - 2}</Badge>
            )}
          </div>
        );
      },
    },
    {
      path: "updatedAt",
      label: "Ostatnia aktualizacja",
      content: (item) => {
        if (!item.updatedAt) return "-";
        const date = new Date(item.updatedAt);
        return (
          <div className="small">
            <div>{date.toLocaleDateString('pl-PL')}</div>
            <div className="text-muted">{date.toLocaleTimeString('pl-PL')}</div>
          </div>
        );
      },
    },
  ];

  editColumn = {
    path: "",
    key: "edit",
    content: (item) => (
      <Button
        onClick={() => this.props.onEdit(item)}
        variant="outline-primary"
        size="sm"
        className="me-2"
        title="Edytuj filtr"
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    ),
  };

  deleteColumn = {
    path: "",
    key: "delete",
    content: (item) => (
      <ConfirmationButton
        label={<FontAwesomeIcon icon={faTrash} />}
        yesLabel="Tak, usuń"
        noLabel="Anuluj"
        variant="outline-danger"
        size="sm"
        title="Usuń filtr"
        onConfirm={() => this.props.onDelete(item)}
      >
        Czy na pewno chcesz usunąć filtr "{item.name}"?
        <br />
        <small className="text-muted">Ta operacja jest nieodwracalna.</small>
      </ConfirmationButton>
    ),
  };

  constructor() {
    super();
    this.columns.push(this.editColumn);
    this.columns.push(this.deleteColumn);
  }

  render() {
    const { filters, onSort, sortColumn } = this.props;
    
    return (
      <UTable
        data={filters}
        columns={this.columns}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default StatusReportFiltersTable;